import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, unref as _unref, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "offer-box__content-container"
}
const _hoisted_2 = { class: "offer-box__title-feature-container" }
const _hoisted_3 = { class: "offer-box__title" }
const _hoisted_4 = { class: "offer-box__flight-price-container" }
const _hoisted_5 = { class: "offer-box__flight-info" }
const _hoisted_6 = { class: "offer-box__flight-icon" }
const _hoisted_7 = { class: "offer-box__flight-text" }
const _hoisted_8 = { class: "offer-box__additional-info" }
const _hoisted_9 = {
  key: 1,
  class: "offer-box__content-no-offer"
}
const _hoisted_10 = { class: "offer-box__title-no-offer" }
const _hoisted_11 = {
  key: 0,
  class: "offer-box__text-no-offer"
}
const _hoisted_12 = {
  key: 1,
  class: "offer-box__text-no-offer"
}
const _hoisted_13 = { class: "offer-box__button-container" }

import { computed } from 'vue';
import BaseIcon from '@lmt-rpb/BaseIcon/BaseIcon.vue';
import RoundedButton from '@lmt-rpb/RoundedButton/RoundedButton.vue';
import { pluralize } from '@utils/utils';
import { normalizeHotelAttributes } from '@/js/utils/arrayUtils'; // Import the utility function
import { getLocaleString } from '@utils/environmentUtils';
import { getTotalPrice } from '@/js/utils/priceUtils';
import {
	NO_OFFER_TITLE,
	NO_OFFER_MESSAGE_PACKAGE,
	NO_OFFER_MESSAGE_NO_PACKAGE,
	BUTTON_TEXT_ALL_OFFERS,
	BUTTON_TEXT_CHANGE_SEARCH,
	LINK_TEXT_WITHOUT_FLIGHT,
	LINK_TEXT_WITH_FLIGHT,
} from '@global-js/constants';
import LinkButton from '@lmt-rpb/Atoms/LinkButton/LinkButton.vue';
import { useStore } from '@/components/common/store';
import roomTypes from '@/js/data/room-types';
import boardTypes from '@/js/data/board-types';
import BasePrice from '@lmt-rpb/Atoms/BasePrice/BasePrice.vue';
import Loading from '@lmt-rpb/Loading/Loading.vue';
import { storeToRefs } from 'pinia';
import { useBreakpointStore } from 'src/store/breakpointsStore';

interface Props {
	allOffersHref: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'OfferBox',
  props: {
    allOffersHref: {}
  },
  emits: ['packageSwitchClick', 'showOffersClick', 'searchUpdateClick'],
  setup(__props: any, { emit: __emit }) {



const emit = __emit;

const store = useStore();

const bestOffer = computed(() => store.state.bestOffer);
const totalPrice = computed(() => getTotalPrice(bestOffer.value?.Pricing ?? {}));
const isLoading = computed(() => store.state.bestOfferLoading);
const hasBestOffer = computed(() => !!bestOffer.value?.Price);
const searchMask = computed(() => store.state.searchMask);
const isPackage = computed(() => !searchMask.value.onlyHotel);
const offerType = computed(() => (isPackage.value ? getLocaleString('package') : 'Hotel'));
const offerTransport = computed(() => (isPackage.value ? 'inkl. Flug' : 'eigene Anreise'));
const roomType = computed(() => bestOffer.value?.Room?.Type || '');
const durationValue = computed(() => bestOffer.value?.duration || '');
const travelers = computed(() => searchMask.value.travelers);
const isDesktop = storeToRefs(useBreakpointStore());
const boardType = computed(
	() => bestOffer.value?.BoardType ?? (searchMask.value.boardTypes.length > 0 ? searchMask.value.boardTypes[0] : '')
);

const duration = computed(() => {
	const unit = ['Tag', 'Tage'] as const;
	return durationValue.value ? `${pluralize(durationValue.value, ...unit)}` : '';
});

const boardLabel = computed(() => {
	const label = boardTypes.find((type: { value: string }) => type.value === boardType.value)?.label;
	return label || '';
});

const room = computed(() => {
	const roomLabel = roomTypes.find((type: { value: string }) => type.value === roomType.value)?.label;
	return roomLabel || bestOffer.value?.Room?.Name || '';
});

const offerBoxClass = computed(() => ({
	'offer-box': true,
	'offer-box--no-offer': !hasBestOffer.value,
}));

const fieldLabel = computed((): string => {
	const adultLabel =
		!isDesktop.value || travelers.value.children.length
			? `${travelers.value.adult} Erw.`
			: pluralize(travelers.value.adult, 'Erwachsener', 'Erwachsene');
	const childLabel = travelers.value.children.length ? `, ${pluralize(travelers.value.children.length, 'Kind', 'Kinder')}` : '';
	return `${adultLabel}${childLabel}`;
});

const features = computed(() => [
	{ label: boardLabel.value, class: 'offer-box__feature-Label' },
	{ label: room.value, class: 'offer-box__feature-room' },
]);

const showWithoutFlight = () => {
	store.commit('searchMask/updateFormData', { onlyHotel: true });
	emit('packageSwitchClick');
};
const showWithFlight = () => {
	store.commit('searchMask/updateFormData', { onlyHotel: false });
	emit('packageSwitchClick');
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(offerBoxClass.value)
  }, [
    (isLoading.value)
      ? (_openBlock(), _createBlock(Loading, {
          key: 0,
          class: "offer-box__loading"
        }))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (hasBestOffer.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("h2", null, _toDisplayString(offerType.value), 1 /* TEXT */)
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(features.value, (feature) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: feature.label,
                      class: "offer-box__feature"
                    }, [
                      _createVNode(BaseIcon, {
                        name: 'check',
                        class: "offer-box__list-icon offer-box__list-icon--available"
                      }),
                      _createElementVNode("div", {
                        class: _normalizeClass(feature.class)
                      }, [
                        _createElementVNode("span", null, _toDisplayString(_unref(normalizeHotelAttributes)(feature.label)), 1 /* TEXT */)
                      ], 2 /* CLASS */)
                    ]))
                  }), 128 /* KEYED_FRAGMENT */))
                ]),
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      (offerTransport.value === 'inkl. Flug')
                        ? (_openBlock(), _createBlock(BaseIcon, {
                            key: 0,
                            name: "planeNew",
                            class: "offer-box__icon"
                          }))
                        : _createCommentVNode("v-if", true),
                      (offerTransport.value === 'eigene Anreise')
                        ? (_openBlock(), _createBlock(BaseIcon, {
                            key: 1,
                            name: "room",
                            class: "offer-box__icon"
                          }))
                        : _createCommentVNode("v-if", true)
                    ]),
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("h3", null, _toDisplayString(offerTransport.value), 1 /* TEXT */)
                    ])
                  ]),
                  (bestOffer.value?.CurrencyCode && bestOffer.value?.Pricing)
                    ? (_openBlock(), _createBlock(BasePrice, {
                        key: 0,
                        class: "offer-box__flight-price",
                        theme: 'accent',
                        prefix: "ab",
                        price: totalPrice.value,
                        currency: bestOffer.value.CurrencyCode
                      }, null, 8 /* PROPS */, ["price", "currency"]))
                    : _createCommentVNode("v-if", true),
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("span", null, _toDisplayString(fieldLabel.value) + " · " + _toDisplayString(duration.value), 1 /* TEXT */)
                  ])
                ])
              ]))
            : _createCommentVNode("v-if", true),
          (!hasBestOffer.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("h2", null, _toDisplayString(_unref(NO_OFFER_TITLE)), 1 /* TEXT */)
                ]),
                (isPackage.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      _createElementVNode("p", null, _toDisplayString(_unref(NO_OFFER_MESSAGE_PACKAGE)), 1 /* TEXT */)
                    ]))
                  : (!isPackage.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                        _createElementVNode("p", null, _toDisplayString(_unref(NO_OFFER_MESSAGE_NO_PACKAGE)), 1 /* TEXT */)
                      ]))
                    : _createCommentVNode("v-if", true)
              ]))
            : _createCommentVNode("v-if", true),
          _createElementVNode("div", _hoisted_13, [
            (hasBestOffer.value)
              ? (_openBlock(), _createBlock(RoundedButton, {
                  key: 0,
                  class: "offer-box__button",
                  theme: "extra",
                  as: "a",
                  href: _ctx.allOffersHref,
                  onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (emit('showOffersClick', $event)), ["stop","prevent"]))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(BUTTON_TEXT_ALL_OFFERS)), 1 /* TEXT */)
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["href"]))
              : (!hasBestOffer.value && !isLoading.value)
                ? (_openBlock(), _createBlock(RoundedButton, {
                    key: 1,
                    class: "offer-box__button",
                    theme: "extra",
                    onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (emit('searchUpdateClick')), ["stop"]))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(BUTTON_TEXT_CHANGE_SEARCH)), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                  }))
                : _createCommentVNode("v-if", true),
            (isPackage.value)
              ? (_openBlock(), _createBlock(LinkButton, {
                  key: 2,
                  class: "offer-box__offer-alternative-button",
                  label: _unref(LINK_TEXT_WITHOUT_FLIGHT),
                  "with-icon": false,
                  onClick: _withModifiers(showWithoutFlight, ["stop"])
                }, null, 8 /* PROPS */, ["label"]))
              : _createCommentVNode("v-if", true),
            (!isPackage.value)
              ? (_openBlock(), _createBlock(LinkButton, {
                  key: 3,
                  class: "offer-box__offer-alternative-button",
                  label: _unref(LINK_TEXT_WITH_FLIGHT),
                  "with-icon": false,
                  onClick: _withModifiers(showWithFlight, ["stop"])
                }, null, 8 /* PROPS */, ["label"]))
              : _createCommentVNode("v-if", true)
          ])
        ], 64 /* STABLE_FRAGMENT */))
  ], 2 /* CLASS */))
}
}

})